export class CoyoteWS {
  vin: string;
  immat: string;
  park_id: string;
  install_id: string;
  abo_end_date: string;
  product_type: string;
  serial_number: string;
  abo_is_monthly: boolean;
  product_subtype: number;
  abo_auto_renewal: boolean;
}

export class AttributeContainer {
  public attributes: Attribute[];
  public coyoteWS: CoyoteWS;
  public constructor(attributeBack?) {
    this.attributes = attributeBack?.attributes || undefined;
    this.coyoteWS = attributeBack?.coyoteWS || undefined;
  }
}

export class Attribute {
  public uid_model: number;
  public value: string;
  public constructor(attributeBack?) {
    this.uid_model = attributeBack?.uid_model || undefined;
    this.value = attributeBack?.value || undefined;
  }
}

export class AttributeModel {
  public uid: number;
  public name: string;
  public object_type: 'device';
  public value_type: 'number' | 'string' | 'date';
  public constructor(attributeBack?) {
    this.uid = attributeBack?.uid || attributeBack?.id_model || undefined;
    this.name = attributeBack?.name || undefined;
    this.object_type = attributeBack?.object_type || undefined;
    this.value_type = attributeBack?.value_type || undefined;
  }
}
